import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import "./style/layout.scss";
import reportWebVitals from './reportWebVitals';
import LoadableComponent from "./components/Loadable";

const App = LoadableComponent({
  loader: () => import("./pages/Application")
});

window["React"] = React;
window["ReactDOM"] = ReactDOM;

ReactDOM.render(<App />,
  document.getElementById('root')
);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();